import { CHANGE_EMAIL, REFRESH_TOKEN } from "../../actionTypes";

const initialState = {};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_EMAIL:
      return { ...state, changedEmail: payload };
    case REFRESH_TOKEN:
      return { ...state, refreshedToken: payload };
    default:
      return state;
  }
};
